<template>
  <section class="search-page">
    <div class="info-block container-mobile">
      <div class="search-form">
        <label for="name" class="hidden-label">
          {{ $t("search.name") }}
        </label>
        <div class="search-row">
          <div class="search-main">
            <input
              v-model="name"
              @input="inputEvent"
              type="text"
              class="input"
              name="name"
              id="name"
              :placeholder="$t('search.inputName')"
            />
          </div>
          <div
            v-if="showExtra"
            @click="showExtra = false"
            class="search-toggle"
          >
            <span class="link-blue-underlined">{{
              $t("search.hideFilter")
            }}</span>
          </div>
          <div v-else @click="showExtra = true" class="search-toggle">
            <span class="link-blue-underlined">
              {{ $t("search.showFilter") }}
            </span>
          </div>
        </div>
        <div
          class="search-extra"
          :class="{ 'search-extra-hidden': !showExtra }"
        >
          <div class="search-group">
            <label class="label"> {{ $t("search.interested") }}:</label>
            <div class="search-block">
              <div class="radio-group">
                <input
                  type="radio"
                  value="1"
                  v-model="gender"
                  @change="getSearch"
                  name="gender"
                  id="gender-1"
                  class="input-radio"
                />
                <label for="gender-1" class="radio-label-alt">{{
                  $t("search.men")
                }}</label>
              </div>
              <div class="radio-group">
                <input
                  type="radio"
                  value="2"
                  v-model="gender"
                  @change="getSearch"
                  name="gender"
                  id="gender-2"
                  class="input-radio"
                />
                <label for="gender-2" class="radio-label-alt">
                  {{ $t("search.women") }}
                </label>
              </div>
            </div>
          </div>
          <div class="search-group">
            <label for="age" class="label">
              {{ $t("search.age") }}:
              <div class="search-age">
                {{ $t("search.ageFrom") }} {{ ageRange[0] }}
                {{ $t("search.ageTo") }} {{ ageRange[1] }}
              </div>
            </label>
            <div class="search-block">
              <div class="search-age">
                {{ $t("search.ageFrom") }} {{ ageRange[0] }}
                {{ $t("search.ageTo") }} {{ ageRange[1] }}
              </div>
              <vue-slider
                v-model="ageRange"
                v-bind="rangeBarOptions"
                @drag-start="rangeDragStart"
                @drag-end="rangeDragEnd"
                @change="rangeChange"
                class="search-range"
              />
            </div>
          </div>
          <div class="search-group">
            <label for="city" class="label"> {{ $t("search.city") }} :</label>
            <div class="search-block">
              <input
                :value="city"
                @input="inputEvent"
                type="text"
                class="input"
                name="city"
                id="city"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="search-results">
        <div v-if="searchLoader" class="search-loader">
          <button class="button button-loader"></button>
        </div>
        <ul v-else-if="!searchIsEmpty('search')" class="search-list">
          <li
            v-for="(searchUser, index) in searchResults"
            :ref="'element' + index"
            :key="searchUser.id"
            class="search-item user-card"
            :class="{
              online: searchUser.online,
            }"
          >
            <router-link
              :to="'/profile/' + searchUser.id"
              class="user-card-wrapper"
            >
              <div
                class="user-card-inner"
                :class="{ 'no-avatar': !searchUser.avatar }"
                :style="{
                  'background-image': searchUser.avatar
                    ? 'url(' + searchUser.avatar + ')'
                    : '',
                }"
              >
                <div :to="'/profile/' + searchUser.id" class="user-card-name">
                  <span class="first-name">{{ searchUser.first_name }}</span>
                  <span>{{ searchUser.last_name }}</span>
                </div>
                <div class="user-card-info">
                  <span
                    v-if="searchUser.city"
                    v-html="formatCity(searchUser.city, searchUser.birthday)"
                  ></span>
                  <span v-if="searchUser.birthday.length == 10"
                    >{{ age(searchUser.birthday) }}&nbsp;{{
                      declineNouns(age(searchUser.birthday), [
                        $t("photos.year"),
                        $t("photos.ofTheYear"),
                        $t("photos.years"),
                      ])
                    }}</span
                  >
                </div>
              </div>
              <!-- <div
                                class="user-item-right"
                            >
                                <searchFriendButton
                                    :searchUser="searchUser"
                                ></searchFriendButton>
                            </div> -->
            </router-link>
          </li>
          <li v-if="moreLoader"><button class="button-loader"></button></li>
        </ul>
        <div v-else class="search-empty">
          {{ $t("noUsers.noUsers") }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { observeListEnd } from "@/mixins/observeListEnd";
import { formatDateTime } from "@/mixins/formatDateTime";
import { declineNouns } from "@/mixins/declineNouns";
// import searchFriendButton from '@/components/Blocks/SearchFriendButton';
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";

export default {
  name: "Search",
  props: {
    i18n: Object,
  },
  components: {
    // searchFriendButton,
    VueSlider,
  },
  mixins: [observeListEnd, formatDateTime, declineNouns],
  data() {
    return {
      name: "",
      searchLoader: false,
      moreLoader: false,
      moreIndex: 0,
      observer: null,
      showExtra: false,
      gender: 2,
      ageRange: [18, 99],
      city: "",
      rangeBarOptions: {
        dotSize: 28,
        height: 3,
        min: 18,
        max: 99,
        tooltip: "none",
      },
      isDragging: false,
      dragChanged: false,
      timer: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/fetchUser",
      userIsEmpty: "user/isEmpty",
      searchResults: "profile/fetchSearch",
      searchIsEmpty: "profile/isEmpty",
      next: "profile/fetchSearchNext",
    }),
  },
  created() {
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting === true) {
          this.showMore();
        }
      },
      { threshold: [0] }
    );
    if (!this.userIsEmpty("user")) {
      this.setDefaults(this.user);
    }
    this.$store.watch(
      (state, getters) => getters["user/fetchUser"],
      (user) => {
        this.setDefaults(user);
      }
    );
  },
  methods: {
    setDefaults(user) {
      this.gender = user.gender ? 3 - user.gender : 2;
      this.getSearch();
    },
    inputEvent(e) {
      //Mobile Chrome v-model fix. Learn more: https://github.com/vuejs/vue/issues/9299 and https://stackoverflow.com/questions/50617865/vue-v-model-input-change-mobile-chrome-not-work
      this[e.target.id] = e.target.value;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.getSearch();
      }, 500);
    },
    getSearch() {
      if (
        (this.name.length > 0 && this.name.length < 3) ||
        (this.city.length > 0 && this.city.length < 3)
      ) {
        return;
      }
      let data = {
        name: encodeURIComponent(this.name),
        gender: this.gender,
        age_from: this.ageRange[0],
        age_to: this.ageRange[1],
        city: encodeURIComponent(this.city),
      };
      if (this.name == "" || this.name.length >= 3) {
        this.searchLoader = true;
        this.$store
          .dispatch("profile/search", data)
          .then(() => {
            this.searchLoader = false;
            this.updateMoreIndex();
            this.observeListEnd("element");
          })
          .catch(() => {
            this.searchLoader = false;
          });
      }
    },
    age(birthday) {
      let bDateArr = birthday.split(".");
      let bDate = new Date();
      bDate.setDate(bDateArr[0]);
      bDate.setMonth(bDateArr[1] - 1);
      bDate.setFullYear(bDateArr[2]);
      bDate = bDate.getTime();
      let years = new Date(+new Date() - bDate).getFullYear() - 1970;
      return years;
    },
    updateMoreIndex() {
      this.moreIndex = this.searchResults.length - 2;
    },
    showMore() {
      if (this.next) {
        this.moreLoader = true;
        this.$store
          .dispatch("profile/searchNext")
          .then(() => {
            this.observeListEnd("element", false, true, true);
            this.moreLoader = false;
          })
          .catch(() => {
            this.moreLoader = false;
          });
      } else {
        this.observeListEnd("element", false, true);
      }
    },
    rangeChange(e) {
      this.dragChanged = true;
      if (!this.isDragging) {
        this.getSearch();
      }
    },
    rangeDragStart() {
      this.isDragging = true;
    },
    rangeDragEnd() {
      if (this.dragChanged) {
        this.getSearch();
      }
      this.dragChanged = false;
      this.isDragging = false;
    },
    formatCity(city, birthday) {
      let newCity = city.replace("-", "&#8209");
      if (birthday.length == 10) {
        newCity += ",";
      }
      return newCity;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_user-item";
@import "~@/assets/styles/components/_user-card";
</style>

<style lang="scss">
@import "~@/assets/styles/components/_vue-slider";
@import "~@/assets/styles/pages/_search";
</style>
